import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Container from '../Container';
import Star from './Star';

const RatingStars = ({ rating, size, ...props }) => {
  const width = useMemo(() => (rating / 5) * 100, [rating]);

  return (
    <Container {...props} fontSize={size}>
      <Container position="relative" display="inline-block">
        <Container
          position="absolute"
          left="0"
          top="0"
          overflow="hidden"
          whiteSpace="nowrap"
          width={`${width}%`}
        >
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star fill="#FFC414" />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star fill="#FFC414" />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star fill="#FFC414" />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star fill="#FFC414" />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star fill="#FFC414" />
          </Container>
        </Container>
        <Container whiteSpace="nowrap">
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star />
          </Container>
          <Container margin="0 0.11em" width="1em" display="inline-block">
            <Star />
          </Container>
        </Container>
      </Container>
    </Container>
  );
};

RatingStars.propTypes = {
  rating: PropTypes.number,
  size: PropTypes.string,
};

RatingStars.defaultProps = {
  rating: 0,
  size: '20px',
};

export default RatingStars;
